import CreatePaymentRequestComponent from '../Pages/TransactionRequests/CreatePaymentRequestComponent';
import RetreivePaymentRequestComponent from '../Pages/TransactionRequests/RetreivePaymentRequestComponent';
import CancelPaymentRequestComponent from '../Pages/TransactionRequests/CancelPaymentRequestComponent';
import RefundRequestComponent from '../Pages/TransactionRequests/RefundRequestComponent';
import ReverseRequestComponent from '../Pages/TransactionRequests/ReverseRequestComponent';
import PrintReceiptComponent from '../Pages/TransactionRequests/PrintReceiptComponent';

const TransactionRequestsComponent = () => {

    return (
        <article className="docs-article" id="section-6">
            <header className="docs-header">
                <h1 className="docs-heading">Transaction Requests <span className="docs-time">Last updated: 2023-06-30</span>
                </h1>
                <section className="docs-intro">
                    <p>To cater to various financial operations, a range of APIs are available. The first API facilitates the submission of purchase transactions, enabling seamless payment acceptance. The second API streamlines the process of submitting refund requests, ensuring efficient processing of customer refunds. Additionally, an API for cancellations simplifies the cancellation of transactions. Merchants can also utilize an API for purchase reversals to initiate reversals for completed purchases. Finally, an API to poll transaction statuses provides real-time updates on the progress and status of transactions, empowering merchants with timely information for effective transaction management.</p>
                    <br />
                    <img className="responsive" src="/assets/images/contents/TransactionFlow.png" alt="Terminal unlink Flow" style={{ marginBottom: "20px" }}></img>
                </section>
            </header>
            <CreatePaymentRequestComponent />
            <RetreivePaymentRequestComponent />
            <CancelPaymentRequestComponent />
            <RefundRequestComponent />
            <ReverseRequestComponent />
            <PrintReceiptComponent />
        </article>
    );
};

export default TransactionRequestsComponent;